import { PathGroup } from '../api/path-group';

export const Paths: PathGroup = {
    base: '/en-US/',
    contact: 'contact',
    fees: 'fees',
    rodo: 'gdpr',
    notarialActivities: {
        base: 'notarial-activities',
        inheritanceLaw: 'inheritance-law',
        familyLaw: 'family-law',
        realEstate: 'real-estate',
        certificates: 'business-matters-and-other-activities',
    }
}
